import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkspaceProjectEventService } from '../../../../socket/workspace/workspace-project/workspace-project-event.service';
import { IProjectContext } from '../../../../../models/project/project-model';

@Injectable()
export class WorkspaceProjectEventListenerService {
    private _projectUpdatedToFetch$ = new Subject<IProjectContext>();
    public projectUpdatedToFetch$ = this._projectUpdatedToFetch$.asObservable();

    private _onProjectCreatedSubject = new Subject<IProjectContext>();
    public onProjectCreated$ = this._onProjectCreatedSubject.asObservable();

    private _onProjectDeletedSubject = new Subject<IProjectContext>();
    public onProjectDeleted$ = this._onProjectDeletedSubject.asObservable();
    constructor(private workspaceProjectEventsService: WorkspaceProjectEventService) {
        this.listenToProjectUpdated();
        this.listenToProjectDeleted();
        this.listenToProjectCreated();
    }

    private listenToProjectUpdated() {
        this.workspaceProjectEventsService.onProjectUpdated().subscribe((data) => {
            this._projectUpdatedToFetch$.next({ projectId: data.projectId });
        });
    }

    private listenToProjectCreated() {
        this.workspaceProjectEventsService.onProjectCreated().subscribe((data) => {
            this._onProjectCreatedSubject.next({ projectId: data.projectId });
        });
    }

    private listenToProjectDeleted() {
        this.workspaceProjectEventsService.onProjectDeleted().subscribe((data) => {
            this._onProjectDeletedSubject.next({ projectId: data.projectId });
        });
    }
}
